import AddIcon from '../../../../ui/components/icons/add-icon';
import FilterIcon from '../../../../ui/components/icons/filter-icon';
import { Button } from '../../../../ui/components/ui/button';
import { OfferListFilter } from '../../constants/offer-list-filter.enum';

const OFFER_FILTER_LABELS: Record<OfferListFilter, string> = {
  [OfferListFilter.OPEN]: 'Offen',
  [OfferListFilter.CLOSED]: 'Abgeschlossen',
  [OfferListFilter.ARCHIVED]: 'Archiv'
};

export interface OfferListToolbarProps {
  filter: OfferListFilter;
  onFilterChange: (filter: OfferListFilter) => void;
  onCreate: () => void;
}

/** Same layout as `products` `ListToolbar`; the filter buttons follow `ArchiveFilterButtons`. */
const OfferListToolbar = ({ filter, onFilterChange, onCreate }: OfferListToolbarProps) => (
  <div className="flex justify-between items-center gap-3">
    <div className="flex gap-3">
      {Object.values(OfferListFilter).map((value) => {
        const isActive = value === filter;
        return (
          <Button
            key={value}
            variant={isActive ? 'default' : 'outline'}
            className="flex gap-3 items-center rounded-2xl px-3 py-2 border text-sm"
            onClick={() => onFilterChange(value)}>
            <FilterIcon active={isActive} />
            {OFFER_FILTER_LABELS[value]}
          </Button>
        );
      })}
    </div>
    <Button className="flex gap-3" onClick={onCreate}>
      <AddIcon />
      <span>Neues Angebot</span>
    </Button>
  </div>
);

export default OfferListToolbar;
